<template>
  <router-view></router-view>
</template>

<script>
import '@/assets/css/newUI.less'
export default {
  name: 'App',
}
</script>

<style>
</style>
